// import { param2Obj } from 'sky-engine/utils'

export default {
  loginByPassword: config => {
    return {
      status: 'SUCCESS',
      message: '',
      content: {
        token:
          'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMzcxMzU2NTYwMCIsImF1dGgiOiIiLCJleHAiOjE2MzM2NjI4OTN9.2yCy-Sq1pxvv3Sa7PAb2qmBcrZ8B7mG9tnJsH-qxBRKdeCN959vgoWHm_AKB2JEL9rtQpGtKvRM77PDtpowuIw' // token登录信息
      }
    }
  },
  loginByUserCode: config => {
    return {
      status: 'SUCCESS',
      message: '',
      content: {
        token: '' // token登录信息
      }
    }
  },
  getUserInfo: config => {
    var data = {
      status: 'SUCCESS',
      content: {
        userId: '11111111',
        phone: '17600861234',
        password: '',
        realName: '张三',
        email: '',
        orgType: 'CUSTOMER',
        roleCode: ['CUSTOMER_ADMIN'],
        organizationId: '1212121212',
        orgName: '总机构',
        area: '1, 11, 111',
        areaPath: '福建省/福州市/连江县',
        orgId: '123456'
      },
      message: null,
      msgArgArr: null,
      msgKey: null
    }
    var flag = true
    return flag ? data : `<html> <script>window.top.location.href = "main.html?action=logout"; </script></html>`
  },
  validateAdminPwd: config => {
    return {
      status: 'SUCCESS',
      content: null,
      msg: ''
    }
  },
  logout: () => {
    return {
      code: 0
    }
  },
  addCustomer: () => {
    return {
      code: 0,
      msg: ''
    }
  },
  checkMe: () => {
    return {
      code: 0,
      msg: '',
      data: '323234324'
    }
  },
  getNotice: () => {
    return {
      code: 0,
      msg: '',
      data: {
        noticeList: [
          {
            text: '云办公3.3版本升级啦，小伙伴速速体验，快来快来',
            image: 'sad'
          },
          {
            text: '云办公3.2版本升级啦',
            image: 'sad'
          },
          {
            text: '云办公3.1版本升级啦',
            image: 'sad'
          }
        ]
      }
    }
  },
  getAlarmAndTipCount: () => {
    return {
      code: 0,
      msg: '',
      data: {
        count: 6,
        level: 'SLIGHT'
      }
    }
  },
  springSeCheck: () => {
    return `<html><script  id="action=login">window.top.location.href = "main.html"; </script></html>`
  },
  configurationWizardGet: () => {
    return {
      content: {
        show: false,
        index: 1,
        isJoinUserExperiencePlan: true,
        customDataArr: [
          {
            key: 'userIndex',
            value: 0
          }
        ]
      },
      message: null,
      status: 'SUCCESS'
    }
  },

  configurationWizardSet: () => {
    return {
      status: 'SUCESS',
      message: '<成功或出错的提示>'
    }
  }
}
